import { getRange } from './date-util';

class TasksUtil {
  static mapTask(task) {
    return {
      id: task.id,
      number: task.number,
      completionDate: task.completion_date,
      trade: task.trade.id,
      tradeLabel: task.trade.label,
      subTrade: task.sub_trade.id,
      floorNumber: task.floor,
      room: task.room,
      name: task.name,
      description: task.description,
      status: task.status,
      bidDueDate: task.bid_due_date,
      awardedContractor: task.awarded_contractor,
      contractorName: task.contractor_name,
      images: task.images.map((newImage) => {
        return {
          id: newImage.id,
          url: newImage.image.url,
          preview: newImage.image.preview.url,
        };
      }),
    };
  }

  /**
   * Check if completion date is 5 days or less than 'today'.
   * @param completionDate
   * @param today (optional)
   * @return {boolean} True is valid, false otherwise.
   */
  static validateTaskCompletionDate(completionDate, today) {
    let result = false;
    if (completionDate !== null) {
      const range = getRange(completionDate, today);
      result =
        range.years > 0 ||
        range.months > 0 ||
        range.days > 5 ||
        (range.days === 5 && (range.hours > 0 || range.minutes > 0));
    }

    return result;
  }
}

export default TasksUtil;



// WEBPACK FOOTER //
// ./src/services/utils/tasks-util.js